import { render, staticRenderFns } from "./WraLoader.vue?vue&type=template&id=a1ed1514&scoped=true&"
import script from "./WraLoader.vue?vue&type=script&lang=ts&"
export * from "./WraLoader.vue?vue&type=script&lang=ts&"
import style0 from "./WraLoader.vue?vue&type=style&index=0&id=a1ed1514&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ed1514",
  null
  
)

export default component.exports